jQuery(document).ready(function () {
  $(".mobile-toggle-button").click(function () {
    $(".custom-filters").toggleClass("show");
  });
  // Open on load any filter dropdown
  function toggleImageFilter() {
    var imageFilter = $(".image-filter");

    if ($(window).width() < 768) {
      imageFilter.removeAttr("open");
    } else {
      imageFilter.attr("open", "open");
    }
  }

  // Call the function on window resize
  $(window).on("resize", function () {
    toggleImageFilter();
  });
  var imageFilter = $(".image-filter");
  if ($(window).width() < 768) {
    imageFilter.removeAttr("open");
  } else {
    imageFilter.attr("open", "open");
  }
  $(".custom-filters details").click(function () {
    var getAttr = $(this).attr("open");
    if (getAttr === "open") {
      $("i", this).removeClass("fa-chevron-up");
      $("i", this).addClass("fa-chevron-down");
    } else {
      $("i", this).removeClass("fa-chevron-down");
      $("i", this).addClass("fa-chevron-up");
    }
  });
  // Variant images as per Products:
  var allTitles = new Set();
  $(".new-variant").each(function () {
    var variantTitle = $(this)
      .attr("variant-title")
      .toLowerCase()
      .replace(/\s+/g, "-");
    allTitles.add(variantTitle);
  });

  // Display each unique title only once
  allTitles.forEach(function (title) {
    if (title === "chic") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/chic.png?v=1674208780' title='Chic'>"
      );
    } else if (title === "chic-maxi") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/chic-maxi.png' title='chic-maxi' />"
      );
    } else if (title === "voila") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/voila.png?v=1674208844' title='voila' >"
      );
    } else if (title === "voila-maxi") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/voila-maxi.png?v=1674208844' title='voila-maxi' />"
      );
    } else if (title === "voila-maxi-plus") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/voila-maxi-plus.png' title='voila-maxi-plus' />"
      );
    } else if (title === "freestyle-(crossed-inner)") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/freestyle-crossed-inner.png?v=1674208962' title='freestyle-(crossed-inner)'>"
      );
    } else if (title === "freestyle") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/freestyle.png' title='freestyle'>"
      );
    } else if (title === "freestyle-(straight-inner)") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/freestyle-straight-inner.png?v=1674208962' title='freestyle-(straight-inner)' />"
      );
    } else if (title === "carre'") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/carre.jpg' title='carre'' />"
      );
    } else if (title === "carre'-mini") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/Carre_mini.jpg' title='carre'-mini' />"
      );
    } else if (title === "posh") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/posh.png?v=1674208735' title='posh' />"
      );
    } else if (title === "vogue" || title === "loose-vogue") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/vogue.png?v=1674208735' title='vogue' />"
      );
    } else if (title === "rectangle") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/rectangle.png?v=1674208470' title='rectangle' />"
      );
    } else if (title === "loose-cap-shawl" || title === "cap-shawl") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/cap-shawl.png' title='loose-cap-shawl' />"
      );
    } else if (title === "square") {
      $(".custom-filters details .filter-images").append(
        "<img src='https://cdn.shopify.com/s/files/1/0490/7955/0119/files/square.png' title='square' />"
      );
    }
  });

  // Price Update on Range
  const variantPrices = [];
  $(".new-variant").each(function () {
    var allVariantPrices = $(this).attr("variant-price");
    variantPrices.push(allVariantPrices);
  });
  const variantColors = [];
  $(".new-variant").each(function () {
    var allVariantColors = $(this).attr("variant-color");
    variantColors.push(allVariantColors);
    // console.log("Al Colors " + allVariantColors);
  });
  // Convert the string prices to numeric values
  var numericPrices = variantPrices.map(function (price) {
    // Remove non-digit characters and convert to a number
    return parseInt(
      price.split(".")[0].replace(/[^\d]/g, "").replace(/,/g, "")
    );
  });
  var minValue = Math.min.apply(Math, numericPrices);
  var maxValue = Math.max.apply(Math, numericPrices);

  $(".range-slider .min-range").val(minValue);
  // $(".range-slider input").attr("min", minValue);
  $(".range-slider .max-range").val(maxValue);
  $(".range-slider input").attr("max", maxValue);

  // On Load Print/Plain Counter

  var printCount = 0;
  var plainCount = 0;
  $(".product-media-card").each(function () {
    if ($(this).attr("plain-hijab")) {
      plainCount++;
    }
    if ($(this).attr("print-hijab")) {
      printCount++;
    }
  });
  $(".print-count").text("( " + printCount + " )");
  $(".plain-count").text("( " + plainCount + " )");
  // Get the Filter Data On Load
  // Function to get the value after the specified key in a URL
  function getValueAfterKey(inputString, key) {
    var keyString = key + "=";
    var index = inputString.indexOf(keyString);
    if (index !== -1) {
      var endIndex = inputString.indexOf("&", index + keyString.length);
      if (endIndex !== -1) {
        return inputString.substring(index + keyString.length, endIndex);
      } else {
        return inputString.substring(index + keyString.length);
      }
    }
    return "";
  }
  function removeTrailingQuestionMark(inputString) {
    if (inputString.endsWith("?")) {
      return inputString.slice(0, -1);
    }
    return inputString;
  }

  // Populate Variant Data on Load
  var currentUrl = window.location.href;
  console.log(currentUrl);

  // Extract the values for "style" and "style_tag" from the URL
  var styleValue = getValueAfterKey(currentUrl, "style");
  var styleTagValue = getValueAfterKey(currentUrl, "style_tag");
  var priceRange = getValueAfterKey(currentUrl, "price-range");
  var styleValueUpdatedBefore = removeTrailingQuestionMark(styleValue);
  var styleTag = removeTrailingQuestionMark(styleTagValue);
  var priceRangeUpdated = removeTrailingQuestionMark(priceRange);
  var minMaxPrices = priceRangeUpdated.split("to");
  var styleTagUpdated = styleTag.split("?")[0];
  var styleValueUpdated = styleValueUpdatedBefore.split("?")[0];

  var minPrice = minMaxPrices[0];
  var maxPrice = minMaxPrices[1];

  minPrice = parseFloat(minPrice);
  maxPrice = parseFloat(maxPrice);

  function filterResultsCount() {
    var allCounts = $("#product-grid .visible-variants").length;
    var notAvailableCounts = $(".not-available").length;
    var totalCounts = Math.max(0, allCounts - notAvailableCounts);
    $(".product-count__text span").text(totalCounts + " Products");
  }

  function applyFilterSidebarText(filterText, filterType, minPrice, maxPrice) {
    $(".new-variant").parent().removeClass("visible-variants hide-variants");

    if (filterType === "style") {
      $(".filter-label").text(filterText);
      $(".filter-label").append(
        "<span class='remove-style' title='Remove Style'>X</span>"
      );
    } else if (filterType === "color") {
      $(".filter-color").text(filterText);
      $(".filter-color").append(
        "<span class='remove-color' title='Remove Color'>X</span>"
      );
    } else if (filterType === "tag") {
      $(".filter-tag").text(filterText);
      $(".filter-tag").append(
        "<span class='remove-tag' title='Remove Tag'>X</span>"
      );
    } else if (filterType === "price") {
      $(".filter-range").text(minPrice + " to " + maxPrice);
      $(".filter-range").append(
        "<span class='remove-prc-range' title='Remove Price'>X</span>"
      );
    }
  }

  function variantDataOnFilter(variant) {
    variant.parent().parent().removeClass("not-available");
    variant.parent().parent().addClass("visible-variants");
    var selectedVariantImg = variant.attr("variant-image");
    var selectedVariantPrice = variant.attr("variant-price");
    console.log("Selected Variant Price " + selectedVariantPrice);
    var variantAvailability = variant.attr("instock");
    var selectedVariantLink = variant.attr("variant-link");
    var getProductLink = variant.parent().find(".card__content a");
    variant
      .parent()
      .find(".card--media .card__media img")
      .addClass("hide-media-image");
    variant
      .parent()
      .find(".card-information .price")
      .addClass("hide-media-price");
    getProductLink.attr("href", selectedVariantLink);
    if (variantAvailability === "available") {
      variant
        .parent()
        .find(".card--media .card__media .media--transparent")
        .append(
          "<img src='" + selectedVariantImg + "' class='new-media-image'>"
        );
    } else {
      // Handle the case when variant is out of stock
      variant.parent().parent().addClass("not-available");
    }
    variant
      .parent()
      .find(".card-information .new-variant-price")
      .text(selectedVariantPrice);
  }

  function printPlainTags(variant) {
    variant.parent().parent().addClass("visible-variants");
    var selectedVariantImg = variant.attr("variant-image");
    var selectedVariantPrice = variant.attr("variant-price");
    var variantAvailability = variant.attr("instock");
    var selectedVariantLink = variant.attr("variant-link");
    var variantType = variant.attr("hijab-tag");
    var getProductLink = variant.parent().find(".card__content a");

    variant
      .parent()
      .find(".card--media .card__media img")
      .addClass("hide-media-image");
    variant
      .parent()
      .find(".card-information .price")
      .addClass("hide-media-price");
    getProductLink.attr("href", selectedVariantLink);

    if (variantAvailability === "available") {
      variant
        .parent()
        .find(".card--media .card__media .media--transparent")
        .append(
          "<img src='" + selectedVariantImg + "' class='new-media-image'>"
        );
      if (variantType === "print") {
        printCount++;
      } else if (variantType === "plain") {
        plainCount++;
      }
    } else {
      variant
        .parent()
        .find(".card--media .card__media")
        .addClass("not-available");
    }

    variant
      .parent()
      .find(".card-information .new-variant-price")
      .text(selectedVariantPrice);
  }

  function variantStylePriceTag(variant) {
    var variantPrice = variant.attr("variant-price");
    if (variantPrice) {
      variantPrice = parseInt(
        variantPrice.split(".")[0].replace(/[^\d]/g, "").replace(/,/g, "")
      );
    }
    var hiJabTag = variant.attr("hijab-tag");
    if (hiJabTag) {
      hiJabTag = hiJabTag.toLowerCase().replace(/\s+/g, "-");
    }
    var variantTitle = variant.attr("variant-title");
    if (variantTitle) {
      variantTitle = variantTitle.toLowerCase().replace(/\s+/g, "-");
    }
    var variantColor = variant.attr("variant-color");
    if (variantColor) {
      variantColor = variantColor.toLowerCase().replace(/\s+/g, "-");
    }
    // Return the variables as an object
    return {
      variantPrice: variantPrice,
      hiJabTag: hiJabTag,
      variantTitle: variantTitle,
      variantColor: variantColor,
    };
  }

  if (
    styleValueUpdated === "" &&
    styleTagUpdated === "" &&
    (isNaN(minPrice) || minPrice === "")
  ) {
    var visibleCounts = $("#product-grid .grid__item").length;
    $(".product-count__text span").text(visibleCounts + " Products");
  } else if (
    styleValueUpdated !== "" &&
    styleTagUpdated === "" &&
    (isNaN(minPrice) || minPrice === "")
  ) {
    applyFilterSidebarText(styleValueUpdated, "style", minPrice, maxPrice);

    $(".new-variant").each(function () {
      var variantData = variantStylePriceTag($(this));
      if (variantData.variantTitle === styleValueUpdated) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  } else if (
    styleValueUpdated === "" &&
    styleTagUpdated !== "" &&
    (isNaN(minPrice) || minPrice === "")
  ) {
    applyFilterSidebarText(styleTagUpdated, "tag", minPrice, maxPrice);

    $(".new-variant").each(function () {
      var variantData = variantStylePriceTag($(this));
      if (variantData.hiJabTag === styleTagUpdated) {
        // // Add the class to the parent element
        $(this).parent().addClass("visible-variants");
      } else {
        // Add the class to the parent element
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  } else if (
    styleValueUpdated === "" &&
    styleTagUpdated === "" &&
    (isNaN(minPrice) || minPrice !== "")
  ) {
    applyFilterSidebarText(
      "Price: " + minPrice + " to " + maxPrice,
      "price",
      minPrice,
      maxPrice
    );
    $(".product-media-card").each(function () {
      var productPrice = parseInt(
        $(".starting-price ", this)
          .text()
          .split(".")[0]
          .replace(/[^\d]/g, "")
          .replace(/,/g, "")
      );
      productPrice = parseFloat(productPrice);
      console.log("Product Price " + productPrice);
      if (productPrice >= minPrice && productPrice <= maxPrice) {
        // // Add the class to the parent element
        $(this).parent().parent().addClass("visible-variants");
      } else {
        // Add the class to the parent element
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  } else if (
    styleValueUpdated !== "" &&
    styleTagUpdated !== "" &&
    (isNaN(minPrice) || minPrice === "")
  ) {
    applyFilterSidebarText(styleValueUpdated, "style", minPrice, maxPrice);
    applyFilterSidebarText(styleTagUpdated, "tag", minPrice, maxPrice);
    $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantData = variantStylePriceTag($(this));
      if (
        variantData.variantTitle === styleValueUpdated &&
        variantData.hiJabTag === styleTagUpdated
      ) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  } else if (
    styleValueUpdated !== "" &&
    styleTagUpdated === "" &&
    (isNaN(minPrice) || minPrice !== "")
  ) {
    applyFilterSidebarText(styleValueUpdated, "style", minPrice, maxPrice);
    applyFilterSidebarText(
      "Price: " + minPrice + " to " + maxPrice,
      "price",
      minPrice,
      maxPrice
    );
    $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantData = variantStylePriceTag($(this));
      if (
        variantData.variantTitle === styleValueUpdated &&
        variantData.variantPrice >= minPrice &&
        variantData.variantPrice <= maxPrice
      ) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  } else if (
    styleValueUpdated === "" &&
    styleTagUpdated !== "" &&
    (isNaN(minPrice) || minPrice !== "")
  ) {
    applyFilterSidebarText(styleTagUpdated, "tag", minPrice, maxPrice);
    applyFilterSidebarText(
      "Price: " + minPrice + " to " + maxPrice,
      "price",
      minPrice,
      maxPrice
    );
    $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantData = variantStylePriceTag($(this));
      if (
        variantData.hiJabTag === styleTagUpdated &&
        variantData.variantPrice >= minPrice &&
        variantData.variantPrice <= maxPrice
      ) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  } else if (
    styleValueUpdated !== "" &&
    styleTagUpdated !== "" &&
    (isNaN(minPrice) || minPrice !== "")
  ) {
    applyFilterSidebarText(styleValueUpdated, "style", minPrice, maxPrice);
    applyFilterSidebarText(styleTagUpdated, "tag", minPrice, maxPrice);
    applyFilterSidebarText(
      "Price: " + minPrice + " to " + maxPrice,
      "price",
      minPrice,
      maxPrice
    );
    $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantData = variantStylePriceTag($(this));
      if (
        variantData.variantTitle === styleValueUpdated &&
        variantData.hiJabTag === styleTagUpdated &&
        variantData.variantPrice >= minPrice &&
        variantData.variantPrice <= maxPrice
      ) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  }

  // Load Function Ends

  // Populate variant images as per variant Name:

  $(".filter-images img").on("click", function () {
    applyFilterSidebarText(styleValueUpdated, "style", minPrice, maxPrice);
    var currentUrl = window.location.href;
    // Check if "style=" parameter is already in the URL
    if (currentUrl.indexOf("style=") === -1) {
      // If not, add the "style=" parameter
      currentUrl += "?style=" + styleValueUpdated;
    } else {
      // If yes, update the existing "style=" parameter
      currentUrl = currentUrl.replace(
        /(style=)[^&]*/,
        "$1" + styleValueUpdated
      );
    }
    // Update the URL
    history.pushState(null, null, currentUrl);
    $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantData = variantStylePriceTag($(this));
      if (variantData.variantTitle === styleValueUpdated) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
  });

  // Tag Filter Function

  $(".filter-ppTags p").on("click", function () {
    console.log($(this).text());
    var printCount = 0;
    var plainCount = 0;
    var flterTag = $(this)
      .attr("hijab-tag-style")
      .toLowerCase()
      .replace(/\s+/g, "-");
    var filterLabel = $(".filter-label")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();

    // Remove classes for all variants initially
    if (filterLabel != "") {
      var currentUrl = window.location.href;

      // Check if "style_tag=" parameter is already in the URL
      if (currentUrl.indexOf("style_tag=") === -1) {
        // If not, add the "style_tag=" parameter
        currentUrl += "?&&style_tag=" + flterTag;
      } else {
        // If yes, update the existing "style_tag=" parameter
        currentUrl = currentUrl.replace(
          /&&style_tag=[^&]*/,
          "&&style_tag=" + flterTag
        );
      }
      // Update the URL
      history.pushState(null, null, currentUrl);
      $(".filter-tag").text(flterTag);
      $(".filter-tag").append(
        "<span class='remove-tag' title='Remove Tag'>X</span>"
      );
      $(".new-variant")
        .parent()
        .parent()
        .removeClass("visible-variants hide-variants");
      $(".new-variant").each(function () {
        $(this).parent().find(".card-information .new-variant-price").show();
        var variantData = variantStylePriceTag($(this));
        if (
          variantData.hiJabTag === flterTag &&
          filterLabel === variantData.variantTitle
        ) {
          printPlainTags($(this));
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
      var getNumber = parseInt($("span", this).text().match(/\d+/)[0]);
      console.log("Print / Plain " + getNumber);
      $(".product-count__text span").text(getNumber + " Products");
    } else {
      alert("Please Select the Style First!");
    }
  });

  // Price Filter Function Starts
  $(".ranges").change(function () {
    var getMinRange = $(".min-range").val();
    var getMaxRange = $(".max-range").val();
    var filterLabel = $(".filter-label")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
    var filterTag = $(".filter-tag")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
     $(".new-variant")
      .parent()
      .parent()
      .removeClass("visible-variants hide-variants");
    $(".filter-range").text(getMinRange + " to " + getMaxRange);
    $(".filter-range").append(
      "<span class='remove-prc-range' title='Remove Price'>X</span>"
    );
    var currentUrl = window.location.href;
    // Check if "price-range=" parameter is already in the URL
    if (currentUrl.indexOf("price-range=") === -1) {
      // If not, add the "price-range=" parameter
      currentUrl += "?price-range=" + getMinRange + "to" + getMaxRange;
    } else {
      // If yes, update the existing "price-range=" parameter
      currentUrl = currentUrl.replace(
        /(price-range=)[^&]*/,
        "$1" + getMinRange + "to" + getMaxRange
      );
    }
    // Update the URL
    history.pushState(null, null, currentUrl);
    if (filterLabel === "" && filterTag === "") {
      $(".product-media-card").each(function () {
        var productPrice = parseInt(
          $(".starting-price ", this)
            .text()
            .split(".")[0]
            .replace(/[^\d]/g, "")
            .replace(/,/g, "")
        );
        productPrice = parseFloat(productPrice);
        if (productPrice <= getMaxRange && productPrice >= getMinRange) {
          $(this).parent().parent().addClass("visible-variants");
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
      var allCounts = $("#product-grid .visible-variants").length;
      var notAvailableCounts = $(".not-available").length;
      // Ensure totalCounts is never negative
      var totalCounts = Math.max(0, allCounts - notAvailableCounts);
      $(".product-count__text span").text(totalCounts + " Products");
    } else if (filterLabel !== "" && filterTag !== "") {
      $(".new-variant").each(function () {
        $(this).parent().find(".card-information .new-variant-price").show();
        var variantData = variantStylePriceTag($(this));
        if (
          variantData.variantPrice >= getMinRange &&
          variantData.variantPrice <= getMaxRange &&
          variantData.hiJabTag === filterTag &&
          variantData.variantTitle === filterLabel
        ) {
          variantDataOnFilter($(this));
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
    } else if (filterLabel !== "" && filterTag === "") {
      $(".new-variant").each(function () {
        $(this).parent().find(".card-information .new-variant-price").show();
        var variantData = variantStylePriceTag($(this));
        if (
          variantData.variantTitle === filterLabel &&
          variantData.variantPrice >= getMinRange &&
          variantData.variantPrice <= getMaxRange
        ) {
          variantDataOnFilter($(this));
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
    } else if (filterLabel === "" && filterTag !== "") {
      $(".new-variant").each(function () {
        $(this).parent().find(".card-information .new-variant-price").show();
        var variantData = variantStylePriceTag($(this));
        if (
          variantData.variantPrice >= getMinRange &&
          variantData.variantPrice <= getMaxRange &&
          variantData.hiJabTag === filterTag
        ) {
          variantDataOnFilter($(this));
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
    }
  });
  // Price Filter Ends Here
  
  // Print or Plain Counter

  $(".filter-images img").on("click", function () {
    $("#product-grid .grid__item").removeClass("not-available");
    var printCount = 0;
    var plainCount = 0;
    var selectedStyle = $(this)
      .attr("title")
      .toLowerCase()
      .replace(/\s+/g, "-");
    $(".filter-label").text(selectedStyle);
    $(".filter-label").append(
      "<span class='remove-style' title='Remove Style'>X</span>"
    );
    $(".new-variant")
      .parent()
      .parent()
      .removeClass("visible-variants hide-variants");
    var currentUrl = window.location.href;
    // Check if "style=" parameter is already in the URL
    if (currentUrl.indexOf("style=") === -1) {
      // If not, add the "style=" parameter
      currentUrl += "?style=" + selectedStyle;
    } else {
      // If yes, update the existing "style=" parameter
      currentUrl = currentUrl.replace(/(style=)[^&]*/, "$1" + selectedStyle);
    }
    // Update the URL
    history.pushState(null, null, currentUrl);
    $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantTitle = $(this)
        .attr("variant-title")
        .toLowerCase()
        .replace(/\s+/g, "-");
      if (variantTitle === selectedStyle) {
        $(this).parent().parent().addClass("visible-variants");
        var selectedVariantImg = $(this).attr("variant-image");
        var selectedVariantPrice = $(this).attr("variant-price");
        var variantAvailability = $(this).attr("instock");
        var variantType = $(this).attr("hijab-tag");
        var selectedVariantLink = $(this).attr("variant-link");
        var getProductLink = $(this).parent().find(".card__content a");
        $(this)
          .parent()
          .find(".card--media .card__media img")
          .addClass("hide-media-image");
        $(this)
          .parent()
          .find(".card-information .price")
          .addClass("hide-media-price");
        getProductLink.attr("href", selectedVariantLink);
        if (variantAvailability === "available") {
          $(this)
            .parent()
            .find(".card--media .card__media .media--transparent")
            .append(
              "<img src='" + selectedVariantImg + "' class='new-media-image'>"
            );
          if (variantType === "print") {
            printCount++;
          } else if (variantType === "plain") {
            plainCount++;
          }
        } else {
          $(this).parent().parent().addClass("not-available");
        }
        $(this)
          .parent()
          .find(".card-information .new-variant-price")
          .text(selectedVariantPrice);
        var allCounts = $("#product-grid .visible-variants").length;
        var notAvailableCounts = $(".not-available").length;
        // Ensure totalCounts is never negative
        var totalCounts = Math.max(0, allCounts - notAvailableCounts);

        $(".product-count__text span").text(totalCounts + " Products");
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });

    // Update counts wherever you want, for example, in specific elements
    $(".print-count").text("( " + printCount + " )");
    $(".plain-count").text("( " + plainCount + " )");
  });

  // Remove Filters Functions

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // Function to remove style or style_tag from URL
  function removeParameter(param) {
    var url = window.location.href;
    var value = getParameterByName(param, url);
    if (value !== null) {
      // Remove the parameter from the URL
      url = url.replace(new RegExp("&?" + param + "=?[^&]*"), "");
      // Handle both cases where the parameter is at the beginning or in the middle
      url = url.replace(/[?&]$|&&/, "");
      // Update the URL without reloading the page
      window.history.replaceState({}, document.title, url);
    }
  }

  // Function to remove style elements
  $(document).on("click", ".remove-style", function () {
    var plainCount = 0;
    var printCount = 0;
    $(this).parent().empty();
    removeParameter("style");
    $(".new-variant")
      .parent()
      .parent()
      .removeClass("visible-variants hide-variants");
    $(".grid__item").removeClass("not-available");
    var filterTag = $(".filter-tag")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
    var filterRange = $(".filter-range")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
      var getMinRange = $(".min-range").val();
      var getMaxRange = $(".max-range").val();
      getMinRange = parseFloat(getMinRange);
      getMaxRange = parseFloat(getMaxRange);
    if (filterTag === "" && filterRange === "") {
      var visibleCounts = $(".product-media-card").length;
      $(".product-count__text span").text(visibleCounts + " Products");
      $(".product-media-card").each(function () {
        if ($(this).attr("plain-hijab")) {
          plainCount++;
        }
        if ($(this).attr("print-hijab")) {
          printCount++;
        }
      });
      $(".print-count").text("( " + printCount + " )");
      $(".plain-count").text("( " + plainCount + " )");
      $(".product-media-card")
        .find(".card__media img")
        .removeClass("hide-media-image");
      $(".new-media-image").hide();
      $(".product-media-card")
        .find(".card-information .price")
        .removeClass("hide-media-price");
      $(".new-variant-price").hide();
      $("#product-grid li").removeClass("hide-variants visible-variants");
      $(".product-media-card a").each(function () {
        var originalHref = $(this).attr("href");
        var indexOfQuestionMark = originalHref.indexOf("?");
        if (indexOfQuestionMark !== -1) {
          var modifiedHref = originalHref.substring(0, indexOfQuestionMark);
          $(this).attr("href", modifiedHref);
        }
      });
    } else if (filterTag !== "" && filterRange === "") {
      $(".new-variant").each(function () {
        var variantTag = $(this)
          .attr("hijab-tag")
          .toLowerCase()
          .replace(/\s+/g, "-");
        if (variantTag === filterTag) {
          // // Add the class to the parent element
          $(this).parent().parent().addClass("visible-variants");
        } else {
          // Add the class to the parent element
          $(this).parent().parent().addClass("hide-variants");
        }
        var visibleCounts = $(".visible-variants").length;
        $(".product-count__text span").text(visibleCounts + " Products");
      });
    } else if (filterTag === "" && filterRange !== "") {
      $(".product-media-card").each(function () {
        var productPrice = parseInt(
          $(".starting-price ", this)
            .text()
            .split(".")[1]
            .replace(/[^\d]/g, "")
            .replace(/,/g, "")
        );
        productPrice = parseFloat(productPrice);
        if (productPrice <= getMaxRange && productPrice >= getMinRange) {
          $(this).parent().parent().addClass("visible-variants");
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
      filterResultsCount();
    }
  });

  // Function to remove tag elements
  $(document).on("click", ".remove-tag", function () {
    var filterLabel = $(".filter-label")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
    $(".new-variant")
      .parent()
      .parent()
      .removeClass("visible-variants hide-variants");
    $(".grid__item").removeClass("not-available");
    $(this).parent().empty();
    var filterRange = $(".filter-range")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
    var getMinRange = $(".min-range").val();
    var getMaxRange = $(".max-range").val();
    getMinRange = parseFloat(getMinRange);
    getMaxRange = parseFloat(getMaxRange);
    removeParameter("style_tag");
    if (filterLabel === "" && filterRange === "") {
      $(".product-media-card")
        .find(".card__media img")
        .removeClass("hide-media-image");
      $(".new-media-image").hide();
      $(".product-media-card")
        .find(".card-information .price")
        .removeClass("hide-media-price");
      $(".new-variant-price").hide();
      $("#product-grid li").removeClass("hide-variants visible-variants");
      $(".product-media-card a").each(function () {
        var originalHref = $(this).attr("href");
        var indexOfQuestionMark = originalHref.indexOf("?");
        if (indexOfQuestionMark !== -1) {
          var modifiedHref = originalHref.substring(0, indexOfQuestionMark);
          $(this).attr("href", modifiedHref);
        }
      });
    } else if(filterLabel !== "" && filterRange === "") {
      $(".new-variant").each(function () {
      $(this).parent().find(".card-information .new-variant-price").show();
      var variantData = variantStylePriceTag($(this));
      if (variantData.variantTitle === filterLabel) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
    filterResultsCount();
    }
    else if (filterLabel === "" && filterRange !== "") {
      $(".product-media-card").each(function () {
        var productPrice = parseInt(
          $(".starting-price ", this)
            .text()
            .split(".")[0]
            .replace(/[^\d]/g, "")
            .replace(/,/g, "")
        );
        productPrice = parseFloat(productPrice);
        if (productPrice <= getMaxRange && productPrice >= getMinRange) {
          $(this).parent().parent().addClass("visible-variants");
        } else {
          $(this).parent().parent().addClass("hide-variants");
        }
      });
      var allCounts = $("#product-grid .visible-variants").length;
      var notAvailableCounts = $(".not-available").length;
      // Ensure totalCounts is never negative
      var totalCounts = Math.max(0, allCounts - notAvailableCounts);
      $(".product-count__text span").text(totalCounts + " Products");
    }
  });

  // Remove Price Filter
  $(document).on("click", ".remove-prc-range", function () {
    $(this).parent().empty();
    removeParameter("price-range");
    var filterLabel = $(".filter-label")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
    var filterTag = $(".filter-tag")
      .contents()
      .filter(function () {
        return this.nodeType === 3; // Filter out non-text nodes (e.g., the span element)
      })
      .text()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .trim();
    $(".grid__item").removeClass("not-available");
    if (filterLabel === "" && filterTag === "") {
      $("#product-grid .grid__item").removeClass("hide-variants");
      $("#product-grid .grid__item").removeClass("visible-variants");
      var visibleCounts = $("#product-grid .grid__item").length;
      $(".product-count__text span").text(visibleCounts + " Products");
    } else if (filterLabel !== "" && filterTag === "") {
      $(".new-variant").each(function () {
      var variantData = variantStylePriceTag($(this));
      if (variantData.variantTitle === filterLabel) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
      filterResultsCount();
    } else if(filterLabel === "" && filterTag !== "") {
       $(".new-variant").each(function () {
      var variantData = variantStylePriceTag($(this));
      if (variantData.hiJabTag === filterTag) {
        variantDataOnFilter($(this));
      } else {
        $(this).parent().parent().addClass("hide-variants");
      }
    });
      filterResultsCount();
    }
  });
  // Price Change Slider

  var parent = $(".range-slider");
  if (!parent.length) return;

  var rangeS = parent.find("input[type=range]"),
    numberS = parent.find("input[type=number]");

  rangeS.on("input", function () {
    var slide1 = parseFloat(rangeS.eq(0).val()),
      slide2 = parseFloat(rangeS.eq(1).val());

    if (slide1 > slide2) {
      [slide1, slide2] = [slide2, slide1];
    }

    numberS.eq(0).val(slide1);
    numberS.eq(1).val(slide2);
  });

  numberS.on("input", function () {
    var number1 = parseFloat(numberS.eq(0).val()),
      number2 = parseFloat(numberS.eq(1).val());

    if (number1 > number2) {
      var tmp = number1;
      numberS.eq(0).val(number2);
      numberS.eq(1).val(tmp);
    }

    rangeS.eq(0).val(number1);
    rangeS.eq(1).val(number2);
  });

  // In Stock Hijabs Count On Load
  var stockCount = 0;
  $(".product-media-card").each(function () {
    var stockHijabValue = $(this).attr("instock");
    // Check and update counters
    if (stockHijabValue && stockHijabValue.toLowerCase() === "available") {
      stockCount++;
    }
  });

  $(".stock-count").text("( " + stockCount + " )");
});